import api from "services/api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_BREATHALYZERS = API_URL_VERSION + "etilometros";
export const ENDPOINT_BREATHALYZERS_LIST = ENDPOINT_BREATHALYZERS + "/listar";

export const breathalyzersService = {
  list: async (params) => {
    try {
      const response = await api.post(ENDPOINT_BREATHALYZERS_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.breathalyzer.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_BREATHALYZERS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.breathalyzer.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_BREATHALYZERS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.breathalyzer.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_BREATHALYZERS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.breathalyzer.messages.errors.update";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_BREATHALYZERS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.breathalyzer.messages.errors.delete";
    }
  },
};
